import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  FormGroup,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel
} from "@material-ui/core";

const styles = (theme) => ({
  radioGroupLabel: {
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    color: theme.popupLeftColColor,
  },
  checkboxLabel: {
    paddingRight: 12,
    marginBottom: 6,
    backgroundColor: theme.radioLabel,
    marginLeft: 0,
    marginRight: 8,
  },
  radioLabelText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText,
  },
  checkBox: {
    color: theme.checkboxColor,
  },
  active: {
    backgroundColor: theme.activeRadioBG,
  },
  disabled: {
    backgroundColor: theme.headerIconColor,
    cursor: "not-allowed",
  },
});

const CheckboxGroup = ({ classes, headerLabel, options, onChange }) => {
  const handleChange = (event) => {
    const updatedSelections = options.map((item) => {
      if (item.name === event.target.name) {
        return { ...item, isChecked: event.target.checked, isLastUpdated: true};
      } else {
        return { ...item, isLastUpdated: false };
      }
    });
    onChange?.(updatedSelections);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel
        component="legend"
        classes={{
          root: classes.radioGroupLabel,
        }}
        focused={false}
      >
        {headerLabel}
      </FormLabel>
      <FormGroup row>
        {options.map((option) => (
          <FormControlLabel
            key={`dynamic_checkbox_group_${option.name}`}
            classes={{
              root: `${classes.checkboxLabel} ${
                option.isChecked ? classes.active : ""
              }`,
              label: classes.radioLabelText,
              disabled: classes.disabled,
            }}
            disabled={option.disabled}
            control={
              <Checkbox
                classes={{ root: classes.checkBox, disabled: classes.disabled }}
                checked={option.isChecked}
                onChange={handleChange}
                name={option.name}
                color="primary"
                disabled={option.disabled}
              />
            }
            label={option.labelText}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default withStyles(styles)(CheckboxGroup);
